<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md12>
      
        <material-card
          color="green"
          title="User List"
          text=""
        >
          <v-data-table :headers="headers" :items="userList">
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-light text--darken-3"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="{ item }">
              <td>{{ item.name }}</td>
              <td>{{ item.email }}</td>
              <td>{{ item.role }}</td>
              <td>
               <v-btn 
                  color="warning"                                    
                  dark                  
                  @click="resetPassword(item)"
                ><v-icon class="mr-2">mdi-lock-reset</v-icon>  Reset Password
                </v-btn>
              </td>
            </template>
          </v-data-table>

          <v-dialog v-model="dialogEdit" width="500" hegiht="auto" persistent>
            <!--       <template v-slot:activator="{ on }">
            
          </template> -->

          <v-card>
            <v-container>
              <material-card title="Reset Password" color="green">
                <v-form ref="formResetPassword" v-model="valid" lazy-validation>
                  <v-container py-0>
                    <v-layout wrap>                   
                     
                      <v-flex md12>
                      <label  class="col-form-label font-weight-bold">User: {{user.name}}</label>
                        <v-text-field
                          type="text"
                          label="Set Password"
                          class="green-input"
                          v-model="userObj.password"
                          prepend-icon="text_fields"
                        />
                      </v-flex>                   
                  

                      <v-flex xs12 text-xs-right>
                        <v-btn
                          class="mx-0 font-weight-light"
                          color="success"
                          :disabled="disableButton"
                           @click="onResetPasswordSubmit"
                          >Submit</v-btn
                        >
                        <v-btn
                          class="mx-2 font-weight-light"
                          color="info"
                          :disabled="disableButton"
                          @click="closeModal"
                          >Close</v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </material-card>
            </v-container>
          </v-card>

          </v-dialog>
        </material-card>

        <v-snackbar
          :color="color"
          :bottom="bottom"
          :top="top"
          :left="left"
          :right="right"
          v-model="snackbar"
          dark
        >
          <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
          <div>{{ errorMessage }}</div>
          <v-icon size="16" @click="snackbar = false">
            mdi-close-circle
          </v-icon>
        </v-snackbar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";

export default {
  components: {
    
  },
  computed: {
    ...mapState("users", ["userList"]),
  },
  mounted() {
    this.getUserlist();
  },
  data() {
    return {  
      valid: true,
      color: null,
      colors: ['success'],
      top: true,
      bottom: false,
      left: false,
      right: false,
      snackbar: false,
      user: {},
      headers: [
        {
          sortable: false,
          text: "Name",
          value: "name",
        },
        {
          sortable: false,
          text: "Email",
          value: "email",
        },    
        {
          sortable: false,
          text: "Role",
          value: "role",
        },
        {
          sortable: false,
          text: "Action",
          value: "action",
        },
      ],
      dialog: false,
      dialogEdit: false,
      errorMessage: "",
      item: {
        title: "Reset Password",
        subTitle: "",
        width: "md6",
        submitText: "Submit",
      },
      userObj: {},   
      courseIDRules: [(v) => !!v || "Thumbnail is required."],
      nameRules: [
        (v) => !!v || "Course name is required",
        (v) =>
          (v && v.length <= 190) ||
          "Course name must be less than 190 characters"
      ],     
      sortRules: [(v) => !!v || "Sort is required"],    
      folderRules: [(v) => !!v || "Folder name is required"],
      disableButton: false,

    
    };
  },
  created() {
    // this.getCourseTypeList()
  },
  methods: {
    ...mapActions("users", [
      "getUserlist",
      "resetUserPassword"
    ]),
    resetPassword(item) {
      this.user = item;
      this.dialogEdit = true;
    },
    closeModal() {
      this.dialogEdit = false;
      this.$refs.formResetPassword.reset();
      this.userObj = {}
      this.user = {}
    },  
    onResetPasswordSubmit() {
  
      if (this.$refs.formResetPassword.validate()) {
 
          let loader = this.$loading.show({
              color: "green",
              canCancel: false,
              onCancel: this.onCancel,
              loader: 'dots',
              isFullPage: true
            });

        this.disableButton = true;
        let obj = {
          id: this.user.id,
          password: this.userObj.password
        }
        this.resetUserPassword(obj)
          .then((response) => {
               loader.hide()
            if (response.status == "OK") {       
              this.closeModal();
               this.$refs.formResetPassword.resetValidation();
              this.disableButton = false;
              this.getUserlist();
              this.color = "success";
              this.errorMessage = "Success! " + response.messages;
              this.snack("top");
            } else {
              this.color = "warning";
             this.errorMessage = "Warning! " + response.messages;
              this.snack("top");
              this.disableButton = false;
            }              

          })
          .catch((err) => {
               loader.hide()
            this.disableButton = false;
            console.log(err);
          });
      } else {
      }
    },

    // EditCourse(data) {
    //   this.updateCourse(data)
    //     .then((response) => {
    //       if (response.status == "OK") {
    //         this.getCrashCourselist();
    //         this.dialogEdit = false;
    //         this.color = "success";
    //         this.errorMessage = response.messages;
    //         this.snack("top");
    //       } else {
    //         this.dialogEdit = false;
    //         this.color = "warning";
    //         this.errorMessage = response.messages;
    //         this.snack("top");
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
    // getBackData(data) {
    //   this.CreateCourse(data)
    //     .then((response) => {
    //       console.log(response);
    //       if (response.status == "OK") {
    //         this.getCrashCourselist();
    //         this.dialog = false;
    //         this.color = "success";
    //         this.errorMessage = response.messages;
    //         this.snack("top");
    //       } else {
    //         this.dialog = false;
    //         this.color = "warning";
    //         this.errorMessage = response.messages;
    //         this.snack("top");
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },


    snack(...args) {
      this.top = false;
      this.bottom = false;
      this.left = false;
      this.right = false;

      for (const loc of args) {
        this[loc] = true;
      }

      this.color = this.colors[Math.floor(Math.random() * this.colors.length)];

      this.snackbar = true;
    },
  },
};
</script>
